module.exports = __webpack_public_path__ + "img/bonus_pc_yn.5d05a180.png";